import { defineComponent as _defineComponent } from 'vue'
import Icon from '../Icon.vue';
import radioIcon from '../../../assets/icon/radio.svg';

interface IProps {
  isSelected: boolean;
}

interface IEmits {
  (e: 'onChange', value: boolean): void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    isSelected: { type: Boolean }
  },
  emits: ["onChange"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'onChange', value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { isSelected: boolean }




function toggleSelect() {
  emits('onChange', !props.isSelected);
}

return { __sfc: true,emits, props, toggleSelect, Icon, radioIcon }
}

})